import { z } from 'zod';

/** E-mail or matricule (e.g. 24GL0137). */
export const LoginInputSchema = z.object({
  identifier: z.string().trim().min(1, 'auth.errors.identifierRequired').max(254),
  password: z.string().min(1, 'auth.errors.passwordRequired').max(200),
  remember: z.boolean().default(true),
});
export type LoginInput = z.input<typeof LoginInputSchema>;

export const ForgotPasswordInputSchema = z.object({
  identifier: z.string().trim().min(1, 'auth.errors.identifierRequired').max(254),
});
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordInputSchema>;

export const PASSWORD_MIN_LENGTH = 10;

export const ResetPasswordInputSchema = z
  .object({
    token: z.string().min(20).max(200),
    password: z.string().min(PASSWORD_MIN_LENGTH, 'auth.errors.passwordTooShort').max(200),
    confirm: z.string(),
  })
  .refine((v) => v.password === v.confirm, { path: ['confirm'], message: 'auth.errors.passwordMismatch' });
export type ResetPasswordInput = z.infer<typeof ResetPasswordInputSchema>;

/** Signed-in change (« Mon compte »): the current password is required, sessions elsewhere are closed. */
export const ChangePasswordInputSchema = z
  .object({
    current: z.string().min(1, 'auth.errors.passwordRequired').max(200),
    password: z.string().min(PASSWORD_MIN_LENGTH, 'auth.errors.passwordTooShort').max(200),
    confirm: z.string(),
  })
  .refine((v) => v.password === v.confirm, { path: ['confirm'], message: 'auth.errors.passwordMismatch' })
  .refine((v) => v.password !== v.current, { path: ['password'], message: 'auth.errors.passwordUnchanged' });
export type ChangePasswordInput = z.infer<typeof ChangePasswordInputSchema>;

export const OkSchema = z.object({ ok: z.literal(true) });
